var SendFile = {};
var ajax_url = 'admin-ajax.php';

jQuery(document).ready(function ($) {
    var self = null;

    SendFile = {
        sendAction: "sendFile",
        sendButton: $("#sendButton"),
        name: $("#sendButton").data("name"),

        init: function () {
            self = this;
            this.initListeners();
            this.showUpload();
        },

        initListeners: function () {
            self.sendButton.on("click", function () {
                self.send();
            });
        },

        showUpload: function () {
            $(".open-xlsx-upload").click(function () {
                $(".pick-upload").hide();
                $(".contact-form-xlsx").show();
                $(".modules-container").show();
            })

            $(".open-multiple-upload").click(function () {
                $(".pick-upload").hide();
                $(".contact-form-multiple").show();
                $(".modules-container").show();
            })
        },

        send: function () {
            var data = {
                'jobId': self.sendAction,
                'files': [{
                    'fileId': 1,
                    'path': 'asd'
                }],
                'modules_to_analyze': {
                    "erzelem": true,
                    "ertekeles": true,
                    "kognicio": true,
                    "aktivitas": true,
                    "tarsas_referencia": true,
                    "tagadas": true,
                    "ter_idoi_perspektiva": true,
                    "pszichologiai_perspektiva": true
                }
            };
            $.ajax({
                type: "POST",
                url: ajax_url,
                data: data,
                dataType: 'JSON',
                success: function (response) {
                },
                error: function (errorThrown) {
                    console.log(errorThrown);
                }
            });
        }
    };
});
